import { render, staticRenderFns } from "./Relationships.vue?vue&type=template&id=6b6bcb46&scoped=true"
import script from "./Relationships.vue?vue&type=script&lang=js"
export * from "./Relationships.vue?vue&type=script&lang=js"
import style0 from "./Relationships.vue?vue&type=style&index=0&id=6b6bcb46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6bcb46",
  null
  
)

export default component.exports